import axios from "axios";

import type {
  IInviteUserVariables,
  ILenderUser,
  IMe,
  IUpdateUserCompanySettingsVariables,
  IUpdateUserVariables,
} from "./types";

export const getMe = async () => {
  const response = await axios.get<IMe>(`/lender/api/v1/me`);

  return response.data;
};

export const updateUser = async (
  lenderCompanyId: number,
  id: number,
  variables: IUpdateUserVariables,
) => {
  const response = await axios.patch<ILenderUser>(
    `/lender/api/v1/lender-companies/${lenderCompanyId}/users/${id}`,
    variables,
  );

  return response.data;
};

export const updateUserCompanySettings = async (
  lenderCompanyId: number,
  userId: number,
  data: IUpdateUserCompanySettingsVariables,
) => {
  const response = await axios.post<ILenderUser>(
    `/lender/api/v1/lender-companies/${lenderCompanyId}/users/${userId}/settings`,
    data,
  );

  return response.data;
};

export const getLenderCompanyUsers = async (lenderCompanyId: number) => {
  const response = await axios.get<{ items: ILenderUser[] }>(
    `/lender/api/v1/lender-companies/${lenderCompanyId}/users`,
  );

  return response.data;
};

export const inviteUser = async (
  lenderCompanyId: number,
  variables: IInviteUserVariables,
) => {
  const response = await axios.post(
    `/lender/api/v1/lender-companies/${lenderCompanyId}/users`,
    variables,
  );

  return response.data;
};

export const deleteUser = async (lenderCompanyId: number, userId: number) => {
  const response = await axios.delete(
    `/lender/api/v1/lender-companies/${lenderCompanyId}/users/${userId}`,
  );

  return response.data;
};
